export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/** Coach backgrounds shown above the first review grid. */
export const coachProfiles: CoachProfile[] = [
  {
    name: 'Mike Reynolds',
    role: 'Youth Lacrosse Coach',
    bio: 'I’ve been coaching youth lacrosse for 7 years, working with players from U8 through U14. I’ve coached both recreational and club teams and have worked with a mix of experienced players and complete beginners.',
  },
  {
    name: 'David Parker',
    role: 'U10 Volunteer Coach',
    bio: 'I started coaching when my son joined a local U10 team. I had never played organized lacrosse myself, so I’ve had to learn a lot of the game while coaching.',
  },
]

/** Results on the field: planning time, no lines, engaged kids. */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'Before No-Lines Lacrosse, I would spend the night before practice searching for drills and trying to figure out how to put them together. I also had kids standing around while I worked with smaller groups. Now I can open the plan for our age group, print it, and run the practice without starting from scratch.',
    author: 'Jason Miller',
    role: 'U10 Coach · Ohio, USA',
  },
  {
    quote:
      'What I like most is that the practices are built around small groups instead of long lines. With 12 kids on the field, I can keep everyone moving instead of having half the team waiting for a turn.',
    author: 'Chris Anderson',
    role: 'U12 Coach · Michigan, USA',
  },
  {
    quote:
      'The structure makes it easy to keep the kids moving. We go from warm-up to small stations to a game, so there’s very little standing around or waiting for a turn.',
    author: 'Sarah Thompson',
    role: 'U10 Girls Coach · Pennsylvania, USA',
  },
  {
    quote:
      'The biggest difference I noticed was how much more engaged the kids were. There was less standing around, more touches on the ball, and they stayed focused for much longer during practice.',
    author: 'Lauren Davis',
    role: 'U10 Coach · New York, USA',
  },
  {
    quote:
      'The kids actually asked to keep playing when practice was over. They were getting more repetitions because they weren’t waiting in line, and I could see their passing becoming more consistent over the next few weeks.',
    author: 'Mark Wilson',
    role: 'U12 Coach · Colorado, USA',
  },
  {
    quote:
      'With our younger group, keeping everyone moving is half the battle. The shorter games and stations kept them involved instead of losing their attention while they waited.',
    author: 'Amanda Lewis',
    role: 'U8 Coach · Texas, USA',
  },
]

/** Club coaches: it works alongside existing club resources. */
export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'I use No-Lines Lacrosse alongside our club’s existing practice structure. It gives me ready-to-run sessions when I know what skill I want to work on but don’t want to spend an hour building the practice myself.',
    author: 'Brian Carter',
    role: 'U12 Coach · Virginia, USA',
  },
  {
    quote:
      'I don’t use it instead of our club’s coaching resources. I use it to fill in the gaps and give me a complete practice when I need one.',
    author: 'Megan Scott',
    role: 'U10 Coach · Ontario, Canada',
  },
  {
    quote:
      'Our club already has drills and coaching resources. What we were missing was a simple way to turn them into a full practice that works for our age group.',
    author: 'Ryan Cooper',
    role: 'U14 Coach · Maryland, USA',
  },
]
